import { Injectable } from "@angular/core";
import { RestService } from "../core/core/rest.service";
import { Observable } from "rxjs";
import { Breadcrumb, Param } from "./breadcrumbs/breadcrumbs.models";

@Injectable()
export class ShellRestService
{  
  private PostBreadcrumbsUrl   = "api/shell/breadcrumbs";  
  private GetLayoutSettingsUrl = "api/shell/layoutsettings";
  private PostLayoutSettingsUrl = "api/shell/layoutsettings/save";
  private PostUserPictureUrl = "api/user/picture/edit";
  private isBlockedCustomerUrl = "api/auth/isBlockedCustomer";

  constructor(private http: RestService) {
  }  

  public GetLayoutSettings(): Observable<any> {
    return this.http.get(this.GetLayoutSettingsUrl);
  }

  public PostBreadcrumbs(path: string, params: Array<Array<Param>>): Observable<Breadcrumb[]> {
    return this.http.post(this.PostBreadcrumbsUrl, {path: path, params: params});
  }

  public PostLayoutSettings(settings: any)  {
    return this.http.post(this.PostLayoutSettingsUrl, settings);
  }

  public PostUserPicture(userPictureData: any)
  {
      return this.http.post(this.PostUserPictureUrl, userPictureData);
  }

  public IsBlockedCustomer(): Observable<boolean> {
    return this.http.get(this.isBlockedCustomerUrl);
  }
}
